<template>
    <el-button :class="checkButtonStyle()" @click="doFunction($event)" style="padding:0" v-if="!disabledFlag">
            <img v-if="imgSrc" :src="imgSrc" class="buttonIcon"/>
            <span class="buttonText" >{{textContent}}</span>
    </el-button>
    <el-button v-else :class="checkButtonStyle()" class="disabledStyle" style="padding:0;pointer-events: none;" disabled>
      <img v-if="imgSrc" :src="imgSrc" class="buttonIcon"/>
            <span class="buttonText" >{{textContent}}</span>
    </el-button>
</template>
<script>

//如果传的函数没有带参数，可以直接在父组件上用:clickFunction="FunctionName"
//如果传的函数带参数，
// 1.需在父组件上用.bind绑定参数，eg：:clickFunction="FunctionName.bind(this,arg1,arg2)"
// 2.或者直接在包含 <designedButton>上包裹的<div> 使用@click="FunctionName(arg1,arg2)"

import { mapState, mapGetters } from "vuex";
export default {
  data(){
    return{
      smallButton:0
    }
  },
  
  created(){
    if(this.type=='small'){
      this.smallButton=1
    }
  },
  props: {
    buttonStyle:{
      type:Number
    },
    imgSrc:{
       type: String
    },
    textContent:{
        type: String
    },
    clickFunction:{
      type:Function
    },
    disabledFlag:{
      type:Boolean
    },
    type:{
      type:String
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll,true)
  },
  methods:{
    checkButtonStyle(){
      let style=''
      if(this.buttonStyle==1){
        style='blueBorderWithWhiteBackground'
      }else if(this.buttonStyle==3){
        style='redBorderWithWhiteBackground'
      }else{
        style='blueBorderWithBlueBackground'
      }
      if(this.smallButton==1){
        style=style+' smallButton'
      }
      return style
    },
    doFunction(e){
      if (this.clickFunction) {
        this.clickFunction()
      }
      e.currentTarget.blur();
    }
  },
  destroyed(){
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch:{
  },
  computed:{
    ...mapGetters(['rs','PROJECT_DIRECTION','languagetype','CURRENT_PAGE_DATA']),
  },

  components: {
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/common.scss";
  .redBorderWithWhiteBackground{
    cursor: pointer;
    width:100%;
    height: 100%;
    border: 1px solid $red06;
    box-sizing: border-box;
    border-radius: 5px;
    align-items: center;
    vertical-align: middle;
    text-align: center;
    display: table;
    .buttonContent{
      vertical-align: middle;
      display: table-cell;
    }
    .buttonIcon{
      width:20px;
      height:20px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .buttonText{
      font-size: 14px;
      color: $red06;
      vertical-align: middle;
    }
  }
  .redBorderWithWhiteBackground:hover{
    border: 1px solid $red06;
    background-color:$red01 !important;
  }
  .redBorderWithWhiteBackground:active{
    border: 1px solid $red06;
    background-color:$red01 !important;
  }
.smallButton{
  border-radius: 2px !important;
}

.disabledStyle{
  opacity: 0.4;
}
  .blueBorderWithWhiteBackground{
    cursor: pointer;
    width:100%;
    height: 100%;
    border: 1px solid $primary-bt-bg-color;
    box-sizing: border-box;
    border-radius: 5px;
    align-items: center;
    vertical-align: middle;
    text-align: center;
    display: table;
    .buttonContent{
      vertical-align: middle;
      display: table-cell;
    }
    .buttonIcon{
      width:20px;
      height:20px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .buttonText{
      font-size: 14px;
      color: $primary-bt-bg-color;
      vertical-align: middle;
    }
  }
  .blueBorderWithWhiteBackground:hover{
    border: 1px solid $primary-bt-bg-color;
    background-color:$blue01 !important;
  }
  .blueBorderWithWhiteBackground:active{
    border: 1px solid $primary-bt-bg-color;
    background-color:$blue01 !important;
  }

    .blueBorderWithBlueBackground{
      cursor: pointer;
    width:100%;
    height: 100%;
    border: 1px solid $primary-bt-bg-color;
    box-sizing: border-box;
    border-radius: 5px;
    align-items: center;
    vertical-align: middle;
    text-align: center;
    display: table;
    background-color:$primary-bt-bg-color !important;
    .buttonContent{
      vertical-align: middle;
      display: table-cell;
    }
    .buttonIcon{
      width:20px;
      height:20px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .buttonText{
      font-size: 14px;
      color: $primary-bt-font-color;
      vertical-align: middle;
    }
  }
  .blueBorderWithBlueBackground:hover{
    background-color:$blue07 !important;
  }
  .blueBorderWithBlueBackground:active{
    background-color:$blue08 !important;
  }

</style>
<style lang="scss">
// .el-button:focus{
//     background-color:#1890ff!important;
//     color: white !important;
//     }
</style>


// WEBPACK FOOTER //
// src/components/ui/DesignedButton.vue